export const TITLE_BREAKDOWN_STATUSES = {
    PROCESSING: 'processing',
    MANUAL_PROCESSING: 'manual_processing',
    MANUAL_FAILED: 'manual_failed',
    COMPLETED: 'completed',
    STALE: 'stale',
}

export const TITLE_BREAKDOWN_PROCESSING = [
    TITLE_BREAKDOWN_STATUSES.PROCESSING,
    TITLE_BREAKDOWN_STATUSES.MANUAL_PROCESSING,
]

export const LEASE_CHAIN_CONVEYANCE_TYPES = [
    'working',
    'royalty',
]

export const TITLE_CHAIN_CONVEYANCE_TYPES = [
    'surface',
    'executive',
    'bonus',
    'delay',
    'royalty',
]

/**
 * Regex to validate whether its an arithmetical formula. it accepts thee e4 basic calculations and parenthesis.
 * It can start with an equals sign (=) to mimic excel's behavior
 * 
 * @example =(1/2+1/4)+1/6*1/8 // this works
 * @example 1/2+1/4 // this works
 * @example 1/2+0.5 // this works
 * @example 1/2+hackerman // this wont work
 */
export const CONVEYANCE_REGEX = /^=?[\d/*+\-().]+[\d)]?$/

export const TITLE_BREAKDOWN_ROW_SIZE = 29